import React from 'react'
import styled from 'styled-components'
import { Spin } from '../ui'

const SpinWapper = styled.div`
  padding: 100px 0 0 0;
  text-align: center;
`

// loading components from code split
// https://umijs.org/plugin/umi-plugin-react.html#dynamicimport
export default props => (
  <SpinWapper data-test="component-page-loading" {...props}>
    <Spin size="large" data-test="page-loading-animation" />
  </SpinWapper>
)
